export const truckingConstants = {
    TRUCKING_FETCHED: 'TRUCKING_FETCHED',
    TRUCKING_FETCHING: 'TRUCKING_FETCHING',
    TRUCKING_SUBMITTED: 'TRUCKING_SUBMITTED',
    TRUCKING_SUBMITTING: 'TRUCKING_SUBMITTING',
    GET_TRUCKINGS: 'GET_TRUCKINGS',
    GET_TRUCKING_BY_ID: 'GET_TRUCKING_BY_ID',
    GET_AUTHORIZED_TRUCKING: 'GET_AUTHORIZED_TRUCKING',
    TRUCKING_BY_BRANCH: 'TRUCKING_BY_BRANCH',
    GET_TRUCKING_FOR_TALLYSHEET: 'GET_TRUCKING_FOR_TALLYSHEET',
    TRUCKING_FOR_ATW: 'TRUCKING_FOR_ATW', 
    TRUCKING_FOR_HUSTLING: 'TRUCKING_FOR_HUSTLING',
    TRUCKING_CTS_REPORT: 'TRUCKING_CTS_REPORT',
    GET_TRUCKING_ALL: 'GET_TRUCKING_ALL',
}